import { useState, useEffect } from 'react';
import { useAuth } from '../AuthContext';
import { useNavigate } from 'react-router-dom';
function UpdateProfile() {
const [profile, setProfile] = useState({
id: null,
first_name: '',
last_name: '',
email: '',
phone: '',
address1: '',
address2: '',
city: '',
	state: '',
	zip: '',
	business_type: 'estate_sales',
	credit_card_fee_pct: '0',
	cc_collection_enabled: false
	  });
const [businessName, setBusinessName] = useState('');
const [loading, setLoading] = useState(true);
const [error, setError] = useState(null);
const [success, setSuccess] = useState(null);
const { user, supabase, logout, refreshSession, fetchWrapper } = useAuth();
const [originalEmail, setOriginalEmail] = useState('');
const [newPassword, setNewPassword] = useState('');
const [confirmPassword, setConfirmPassword] = useState('');
const validStates = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'];
const navigate = useNavigate();
const normalizeAddressPart = (part, type) => {
if (!part) return '';
if (type === 'state') return part.toUpperCase();
return part.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  };
const validateState = (state) => {
if (!state) return true; // Allow empty state
const upperState = state.toUpperCase();
return validStates.includes(upperState);
  };
const validateAddress = async (addressString) => {
if (!addressString || addressString.trim() === '') {
console.log('UpdateProfile: Address is empty or invalid');
return false;
    }
if (!/^[a-zA-Z0-9\s,.-]+$/i.test(addressString) || addressString.length < 10) {
console.log('UpdateProfile: Address fails basic regex or length check');
return false;
    }
const apiKey = process.env.REACT_APP_GEOAPIFY_API_KEY;
const url = `https://api.geoapify.com/v1/geocode/search?text=${encodeURIComponent(addressString)}&limit=1&type=street&lang=en&apiKey=${apiKey}`;
try {
const response = await fetch(url);
const data = await response.json();
if (data.features && data.features.length > 0) {
const confidence = data.features[0].properties.rank?.confidence || 0;
console.log(`UpdateProfile: GeoApify confidence score: ${confidence}`);
return confidence >= 0.65;
      }
return false;
    } catch (err) {
console.error(`UpdateProfile: GeoApify error: ${err}`);
return false;
    }
  };
const formatPhoneNumber = (value) => {
const cleaned = ('' + value).replace(/\D/g, '');
const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
if (match) {
return !match[2] ? match[1] : `(${match[1]}) ${match[2]}${match[3] ? `-${match[3]}` : ''}`;
    }
return value;
  };
const validatePhone = (phone) => {
const cleaned = (phone || '').replace(/\D/g, '');
return cleaned.length === 10;
  };
const validateMandatoryAddressFields = (address1, city) => {
const trimmedAddress1 = (address1 || '').trim();
const trimmedCity = (city || '').trim();
if (trimmedAddress1 === '' || trimmedCity === '') return false;
return trimmedAddress1.length >= 5 && trimmedCity.length >= 2;
	  };
const sanitizePercentInput = (value) => {
const text = String(value ?? '');
const cleaned = text.replace(/[^\d.]/g, '');
const dotIndex = cleaned.indexOf('.');
if (dotIndex === -1) return cleaned.slice(0, 3);
const intPart = cleaned.slice(0, dotIndex).slice(0, 3);
const fractional = cleaned.slice(dotIndex + 1).replace(/\./g, '').slice(0, 2);
return `${intPart}.${fractional}`;
	  };
const parsePercent = (value) => {
const parsed = Number(value);
if (!Number.isFinite(parsed)) return null;
if (parsed < 0 || parsed > 100) return null;
return Number(parsed.toFixed(2));
	  };
const fetchProfile = async () => {
setLoading(true);
setError(null);
try {
if (!user) {
setError('Please sign in.');
console.log(`${new Date().toISOString()} - UpdateProfile: No user, skipping fetch`);
return;
      }
const profileResponse = await fetchWrapper(`${process.env.REACT_APP_API_URL}/supabase/rpc/select_profile`, {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({ p_client_id: user.id }),
      });
if (!profileResponse) return; // Wrapper handled error
const profileData = await profileResponse.json();
const fetchedProfile = profileData[0] || profile;
const profileWithDefaults = {
...fetchedProfile,
id: fetchedProfile.id || null,
phone: fetchedProfile.phone ? formatPhoneNumber(fetchedProfile.phone) : '',
address1: fetchedProfile.address1 || '',
address2: fetchedProfile.address2 || '',
city: fetchedProfile.city || '',
	state: fetchedProfile.state || '',
	zip: fetchedProfile.zip || '',
	business_type: fetchedProfile.business_type || 'estate_sales',
		credit_card_fee_pct: String(fetchedProfile.credit_card_fee_pct ?? '0'),
	cc_collection_enabled: Boolean(fetchedProfile.cc_collection_enabled)
	      };
setProfile(profileWithDefaults);
setOriginalEmail(fetchedProfile.email || '');
const clientResponse = await fetchWrapper(`${process.env.REACT_APP_API_URL}/supabase/rpc/select_client`, {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({ p_client_id: user.id }),
      });
if (!clientResponse) return; // Wrapper handled error
const clientData = await clientResponse.json();
setBusinessName(clientData[0]?.name || '');
    } catch (err) {
setError(`Error loading profile: ${err.message}`);
console.error(`${new Date().toISOString()} - UpdateProfile: Fetch error:`, err);
    } finally {
setLoading(false);
    }
  };
useEffect(() => {
fetchProfile();
  }, [user]);
const handleChange = (e) => {
const { name, value } = e.target;
let newValue = value;
	if (name === 'phone') {
	newValue = formatPhoneNumber(value);
	    } else if (name === 'credit_card_fee_pct') {
	newValue = sanitizePercentInput(value);
	    } else if (name === 'businessName') {
	setBusinessName(value);
	return;
    }
setProfile({ ...profile, [name]: newValue || '' });
  };
const handlePhoneBlur = (e) => {
const phone = e.target.value;
console.log('UpdateProfile: Phone blur, value:', phone);
if (!validatePhone(phone)) {
setError('Phone number is required and must be exactly 10 numeric digits.');
    } else {
setError(null);
    }
  };
const handleUpdate = async (e) => {
e.preventDefault();
setLoading(true);
setError(null);
setSuccess(null);
	// Phone validation
	if (!validatePhone(profile.phone)) {
setError('Phone number is required and must be exactly 10 numeric digits.');
setLoading(false);
	return;
	    }
		const creditCardFeePct = parsePercent(profile.credit_card_fee_pct);
	if (creditCardFeePct === null) {
	setError('Credit card fee must be between 0 and 100.');
	setLoading(false);
	return;
	    }
	// Normalize address
const normAddress1 = normalizeAddressPart(profile.address1);
const normAddress2 = normalizeAddressPart(profile.address2);
const normCity = normalizeAddressPart(profile.city);
const normState = normalizeAddressPart(profile.state, 'state');
const normZip = profile.zip;
// Validate mandatory fields
if (!validateMandatoryAddressFields(normAddress1, normCity)) {
setError('Address line 1 (min 5 chars) and city (min 2 chars) are required.');
setLoading(false);
return;
    }
// Validate state
if (!validateState(normState)) {
setError('Invalid US state code (e.g., NY).');
setLoading(false);
return;
    }
// Validate address with GeoApify
const street = [normAddress1, normAddress2].filter(Boolean).join(', ');
const cityPart = normCity ? `${normCity}, ` : '';
const statePart = normState ? `${normState} ` : '';
const zipPart = normZip || '';
const addressString = `${street}${street ? ', ' : ''}${cityPart}${statePart}${zipPart}`.trim();
console.log('UpdateProfile: Normalized constructed addressString:', addressString);
const isAddressValid = await validateAddress(addressString);
if (!isAddressValid) {
setError('Invalid address. Please check and try again.');
setLoading(false);
return;
    }
// Clean phone
const cleanedPhone = profile.phone.trim().replace(/\D/g, '');
if (cleanedPhone.length !== 10) {
setError('Phone number must be exactly 10 numeric digits.');
setLoading(false);
return;
    }
const payload = {
p_id: profile.id,
p_client_id: user.id,
p_first_name: profile.first_name,
p_last_name: profile.last_name,
p_email: profile.email,
p_phone: cleanedPhone,
p_address1: normAddress1 || null,
p_address2: normAddress2 || null,
	p_city: normCity || null,
	p_state: normState || null,
	p_zip: normZip || null,
	p_business_type: profile.business_type,
	p_credit_card_fee_pct: creditCardFeePct
	    };
try {
if (!user) {
setError('Please sign in.');
return;
      }
let stripeSyncSuccess = true;
if (profile.email !== originalEmail) {
const stripeResponse = await fetchWrapper(`${process.env.REACT_APP_API_URL}/stripe/update-stripe-email`, {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({ userId: user.id, oldEmail: originalEmail, newEmail: profile.email }),
        });
if (!stripeResponse) {
stripeSyncSuccess = false;
        } else {
const stripeData = await stripeResponse.json();
if (!stripeData.success) {
stripeSyncSuccess = false;
console.error('Stripe email update failed:', stripeData.error);
          }
        }
const { error: authError } = await supabase.auth.updateUser({ email: profile.email }, { emailRedirectTo: `${window.location.origin}/confirm-email` });
if (authError) {
throw new Error(`Email update failed: ${authError.message}`);
        }
      }
const profileResponse = await fetchWrapper(`${process.env.REACT_APP_API_URL}/supabase/rpc/update_profile`, {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify(payload),
      });
if (!profileResponse) return; // Wrapper handled error
const clientResponse = await fetchWrapper(`${process.env.REACT_APP_API_URL}/supabase/rpc/update_client`, {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({ p_client_id: user.id, p_name: businessName }),
      });
if (!clientResponse) return; // Wrapper handled error
if (profile.email !== originalEmail) {
setSuccess('Profile updated! Confirmation email sent to new address—please check your email (including spam) and click the link to complete the change.' + (stripeSyncSuccess ? '' : ' However, failed to sync email with Stripe. Contact support.'));
      } else {
setSuccess('Profile updated successfully!');
      }
console.log(`${new Date().toISOString()} - UpdateProfile: Update successful`);
await fetchProfile();
    } catch (err) {
setError(`Error updating profile: ${err.message}`);
console.error(`${new Date().toISOString()} - UpdateProfile: Update error:`, err);
    } finally {
setLoading(false);
    }
  };
const handlePasswordUpdate = async (e) => {
e.preventDefault();
setError(null);
setSuccess(null);
if (!newPassword || newPassword !== confirmPassword) {
setError('Passwords must match and cannot be empty.');
return;
    }
if (newPassword.length < 6) {
setError('Password must be at least 6 characters long.');
return;
    }
try {
await refreshSession();
const { data, error: authError } = await supabase.auth.updateUser({ password: newPassword });
console.log('UpdateUser response:', data, 'Error:', authError);
if (authError) {
throw new Error(`Password update failed: ${authError.message}`);
      }
setSuccess('Password updated successfully! Signing out—please sign in with new password.');
setNewPassword('');
setConfirmPassword('');
await logout();
setTimeout(() => navigate('/signin'), 3000);
    } catch (err) {
setError(err.message);
    }
  };
return (
<div className="min-h-screen flex flex-col bg-gray-100 pt-16">
<div className="flex-grow p-4">
<div className="max-w-2xl mx-auto bg-white p-6 rounded-lg shadow-md">
<h2 className="text-2xl font-bold mb-4 text-center">Update Profile</h2>
{error && <p className="text-red-500 mb-4 text-center">{error}</p>}
{success && <p className="text-green-500 mb-4 text-center">{success}</p>}
<form onSubmit={handleUpdate} className="space-y-4">
<div>
<label className="block mb-1 text-gray-700">Business Name</label>
<input
type="text"
name="businessName"
value={businessName}
onChange={handleChange}
className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
required
/>
</div>
<div>
<label className="block mb-1 text-gray-700">Business Type</label>
<select
name="business_type"
value={profile.business_type}
onChange={handleChange}
className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
required
>
	<option value="estate_sales">Estate Sales</option>
	</select>
	</div>
		<div>
			<label className="block mb-1 text-gray-700">Manual Card Fee (%)</label>
			{profile.cc_collection_enabled ? (
			<p className="mt-1 text-sm text-slate-500">
				Stripe Connect is enabled. QR payment fee recovery is controlled by the credit-card fee rate table, not this profile field.
			</p>
			) : (
		<input
		type="number"
		name="credit_card_fee_pct"
		value={profile.credit_card_fee_pct}
		onChange={handleChange}
		className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
		min="0"
		max="100"
		step="0.01"
		required
		/>
			)}
		</div>
	<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
<div>
<label className="block mb-1 text-gray-700">First Name</label>
<input
type="text"
name="first_name"
value={profile.first_name}
onChange={handleChange}
className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
required
/>
</div>
<div>
<label className="block mb-1 text-gray-700">Last Name</label>
<input
type="text"
name="last_name"
value={profile.last_name}
onChange={handleChange}
className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
required
/>
</div>
</div>
<div>
<label className="block mb-1 text-gray-700">Email</label>
<input
type="email"
name="email"
value={profile.email}
onChange={handleChange}
className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
required
/>
</div>
<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
<div>
<label className="block mb-1 text-gray-700">Phone</label>
<input
type="tel"
name="phone"
value={profile.phone}
onChange={handleChange}
onBlur={handlePhoneBlur}
className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
required
pattern="\(\d{3}\) \d{3}-\d{4}"
title="Phone number must be in the format (XXX) XXX-XXXX"
maxLength={14}
/>
</div>
<div>
<label className="block mb-1 text-gray-700">Address Line 1</label>
<input
type="text"
name="address1"
value={profile.address1 || ''}
onChange={handleChange}
className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
required
/>
</div>
<div>
<label className="block mb-1 text-gray-700">Address Line 2</label>
<input
type="text"
name="address2"
value={profile.address2 || ''}
onChange={handleChange}
className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
/>
</div>
<div>
<label className="block mb-1 text-gray-700">City</label>
<input
type="text"
name="city"
value={profile.city || ''}
onChange={handleChange}
className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
required
/>
</div>
<div>
<label className="block mb-1 text-gray-700">State</label>
<input
type="text"
name="state"
value={profile.state || ''}
onChange={handleChange}
className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
pattern="[A-Za-z]{2}"
title="State must be a 2-letter US code (e.g., NY)"
maxLength={2}
/>
</div>
<div>
<label className="block mb-1 text-gray-700">Zip Code</label>
<input
type="text"
name="zip"
value={profile.zip || ''}
onChange={handleChange}
className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
/>
</div>
</div>
<button
type="submit"
className="w-full bg-blue-500 text-white p-2 rounded-lg hover:bg-blue-600 disabled:bg-gray-400"
disabled={loading}
>
{loading ? 'Updating...' : 'Update Profile'}
</button>
</form>
<div className="mt-8">
<h3 className="text-xl font-bold mb-4 text-center">Change Password</h3>
<form onSubmit={handlePasswordUpdate} className="space-y-4">
<div>
<label className="block mb-1 text-gray-700">New Password</label>
<input
type="password"
value={newPassword}
onChange={(e) => setNewPassword(e.target.value)}
className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
required
/>
</div>
<div>
<label className="block mb-1 text-gray-700">Confirm New Password</label>
<input
type="password"
value={confirmPassword}
onChange={(e) => setConfirmPassword(e.target.value)}
className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
required
/>
</div>
<button
type="submit"
className="w-full bg-green-500 text-white p-2 rounded-lg hover:bg-green-600"
>
                Update Password
</button>
</form>
</div>
</div>
</div>
</div>
  );
}
export default UpdateProfile;
